import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { OfferBanner } from './components/ui/OfferBanner';
// Lazy load components below the fold
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Solution = lazy(() => import('./components/Solution').then(m => ({
  default: m.Solution
})));
const WhatIncluded = lazy(() => import('./components/WhatIncluded').then(m => ({
  default: m.WhatIncluded
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const ForWho = lazy(() => import('./components/ForWho').then(m => ({
  default: m.ForWho
})));
const Transformation = lazy(() => import('./components/Transformation').then(m => ({
  default: m.Transformation
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofNotification = lazy(() => import('./components/ui/SocialProofNotification').then(m => ({
  default: m.SocialProofNotification
})));
// Simple loading placeholder
function SectionLoader() {
  return <div className="py-16 flex justify-center" data-id="element-0">
      <div className="w-8 h-8 border-2 border-[#0D3B66]/20 border-t-[#0D3B66] rounded-full animate-spin" data-id="element-1"></div>
    </div>;
}
export function App() {
  return <>
      <OfferBanner data-id="element-2" />
      <main className="min-h-screen w-full bg-[#FDFBF9] text-[#2E2E2E] font-sans selection:bg-[#0D3B66] selection:text-white pt-10" data-id="element-3">
        {/* Hero loads immediately - above the fold */}
        <Hero data-id="element-4" />

        {/* Lazy loaded sections - below the fold */}
        <Suspense fallback={<SectionLoader data-id="element-6" />} data-id="element-5">
          <PainPoints data-id="element-7" />
        </Suspense>
        <Suspense fallback={<SectionLoader data-id="element-9" />} data-id="element-8">
          <Solution data-id="element-10" />
        </Suspense>
        <Suspense fallback={<SectionLoader data-id="element-12" />} data-id="element-11">
          <WhatIncluded data-id="element-13" />
        </Suspense>
        <Suspense fallback={<SectionLoader data-id="element-15" />} data-id="element-14">
          <Bonuses data-id="element-16" />
        </Suspense>
        <Suspense fallback={<SectionLoader data-id="element-18" />} data-id="element-17">
          <ForWho data-id="element-19" />
        </Suspense>
        <Suspense fallback={<SectionLoader data-id="element-21" />} data-id="element-20">
          <Transformation data-id="element-22" />
        </Suspense>
        <Suspense fallback={<SectionLoader data-id="element-24" />} data-id="element-23">
          <Pricing data-id="element-25" />
        </Suspense>
        <Suspense fallback={<SectionLoader data-id="element-27" />} data-id="element-26">
          <FAQ data-id="element-28" />
        </Suspense>
        <Suspense fallback={<SectionLoader data-id="element-30" />} data-id="element-29">
          <Footer data-id="element-31" />
        </Suspense>
        <Suspense fallback={null} data-id="element-32">
          <SocialProofNotification data-id="element-33" />
        </Suspense>
      </main>
    </>;
}